import React from 'react';
import { FacebookLogo, InstagramLogo, PinterestLogo, YoutubeLogo } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';
import { useI18n } from '../../i18n';

const Footer = () => {
  const { settings } = useSettings();
  const { t } = useI18n();
  const year = new Date().getFullYear();
  const siteName = settings?.general?.siteName || 'Tafsir Art';
  const email = 'tafsirart@gmail.com';

  const socialClass = 'grid h-10 w-10 place-items-center rounded-full border border-border text-text-secondary transition-colors hover:border-primary hover:text-primary';

  return (
    <footer className="border-t border-border bg-surface text-text-primary">
      <div className="page-shell grid gap-12 py-14 lg:grid-cols-[1.1fr_.7fr_.7fr_1.2fr]">
        <div>
          <Link to="/" className="inline-flex items-center gap-3">
            <img src="/favicon.ico" alt="" className="h-9 w-9 object-contain" aria-hidden="true" />
            <span className="font-display text-3xl font-semibold tracking-[-.03em]">{siteName}</span>
          </Link>
          <p className="mt-5 max-w-sm leading-7 text-text-secondary">{t('footer.note')}</p>
          <div className="mt-6 flex gap-2">
            <a href="https://www.instagram.com/tafsirart/" target="_blank" rel="noopener noreferrer" className={socialClass} aria-label="Instagram"><InstagramLogo size={19} /></a>
            <a href="https://www.facebook.com/share/19h2DJYBB5/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className={socialClass} aria-label="Facebook"><FacebookLogo size={19} /></a>
            <a href="https://pin.it/1D7BeX4H7" target="_blank" rel="noopener noreferrer" className={socialClass} aria-label="Pinterest"><PinterestLogo size={19} /></a>
            <a href="https://www.youtube.com/@TAFSIRART" target="_blank" rel="noopener noreferrer" className={socialClass} aria-label="YouTube"><YoutubeLogo size={19} /></a>
          </div>
        </div>

        <div>
          <h2 className="editorial-eyebrow mb-5">{t('footer.explore')}</h2>
          <nav className="grid gap-3 text-sm text-text-secondary">
            <Link to="/gallery" className="hover:text-primary">{t('common.gallery')}</Link>
            <Link to="/store" className="hover:text-primary">{t('common.store')}</Link>
            <Link to="/blog" className="hover:text-primary">{t('common.blog')}</Link>
          </nav>
        </div>

        <div>
          <h2 className="editorial-eyebrow mb-5">{t('footer.studio')}</h2>
          <nav className="grid gap-3 text-sm text-text-secondary">
            <Link to="/about" className="hover:text-primary">{t('common.about')}</Link>
            <Link to="/contact" className="hover:text-primary">{t('common.contact')}</Link>
            <a href={`mailto:${email}`} className="break-all hover:text-primary">{email}</a>
            <a href="tel:+27641304056" className="hover:text-primary">+27 64 130 4056</a>
          </nav>
        </div>

        <div>
          <p className="editorial-eyebrow mb-3">{t('footer.newsletter')}</p>
          <h2 className="font-display text-3xl font-semibold">{t('footer.newsletterCopy')}</h2>
          <form onSubmit={(event) => event.preventDefault()} className="mt-6 flex gap-2">
            <input type="email" required placeholder={t('footer.email')} className="field min-w-0" />
            <button type="submit" className="btn-primary whitespace-nowrap">{t('footer.subscribe')}</button>
          </form>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="page-shell flex flex-col gap-2 py-5 text-xs text-text-muted sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteName}. {t('footer.rights')}</p>
          <p>Johannesburg</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
